// Coach output contract. ARCHITECTURE.md §5 (CoachText), §5 cache-key note (provenance).
import { z } from 'zod';
/** The four named explanation slots the LLM may fill - the ONLY possible LLM output
 *  (schema-constrained). No strategy is invented here; it phrases the engine's conclusions. */
export const CoachTextSchema = z.object({
    beginner_thought: z.string(),
    pro_thought: z.string(),
    /** street > preflop only. */
    what_changed: z.string().optional(),
    villain_read: z.string(),
});
/** Stored alongside CoachText in KV (ARCHITECTURE.md §5). */
export const CoachProvenanceSchema = z.object({
    model: z.string(),
    promptVersion: z.string(),
    createdAt: z.number().int().nonnegative(),
});
/** The four slot names, reused by the /api/coach request. */
export const CoachSlotSchema = z.enum([
    'beginner_thought',
    'pro_thought',
    'what_changed',
    'villain_read',
]);
//# sourceMappingURL=coach.js.map